import { kind as restart } from '../../actions/goals/Restart';
import { kind as start } from '../../actions/goals/Start';
import { reject } from '../../GoalResolvers';
import { State } from '../../State';
import { clean } from './clean';
import { initialize } from './initialize';

export function rebuild(state: State): State {
  let goalResolvers = state.goalResolvers;
  const reason = 'Rebuilding';
  goalResolvers = reject(goalResolvers, start, reason);
  goalResolvers = reject(goalResolvers, restart, reason);

  if (state.cleaned && !state.database) {
    return initialize(state);
  }

  return clean({ ...state, goalResolvers });
}
